export const DEFAULT_PAGE_TITLE = "Jerelia — краса, здоров’я та турбота щодня";

export const DEFAULT_PAGE_DESCRIPTION =
    "Jerelia — український бренд косметики, парфумерії, товарів для здоров’я та дому. Обирайте улюблені продукти й замовляйте онлайн.";

export const INTERACTIVE_CATALOG_DESCRIPTION =
    "Переглядайте актуальний інтерактивний каталог Jerelia: косметика, парфумерія, товари для здоров’я та дому з можливістю швидкого замовлення.";
